
import { useAxios } from '../../../../../../../../hooks/useAxios';
import { AparatoAdapters } from '../adapters/aparato.adapter';

const AparatoServices = {

    GET: function () {

        return useAxios({ method: 'get', url: `/slam/producto`, type: 'json', adapters: AparatoAdapters.GET })
    },

    POST: function () {

        return useAxios({ method: 'post', url: `/slam/producto`, type: 'json', adapters: AparatoAdapters.POST })
    },

    PATCH: function (idproducto: any) {

        return useAxios({ method: 'patch', url: `/slam/producto/${idproducto}/update`, type: 'json', adapters: AparatoAdapters.PATCH })
    },

    DELETE: function (idproducto: any) {

        return useAxios({ method: 'DELETE', url: `/slam/producto/delete/${idproducto}`, type: 'json', adapters: AparatoAdapters.DELETE })
    },

    DELETE_BAJA: function (idproducto: any) {

        return useAxios({ method: 'DELETE', url: `/slam/producto/baja/${idproducto}`, type: 'json', adapters: AparatoAdapters.DELETE_BAJA })
    },

    POST_IMAGEN: function (idproducto: string) {

        return useAxios({ method: 'post', url: `/slam/img/${idproducto}`, type: 'json', adapters: AparatoAdapters.POST_IMAGEN })
    },
    
    DELETE_IMAGE: function (idproducto: any) {

        return useAxios({ method: 'delete', url: `/slam/producto/delete/img/${idproducto}`, type: 'json', adapters: AparatoAdapters.GET })
    },
}

export {
    AparatoServices
}